import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../context/AuthContext'
import { useAnalytics } from '../context/AnalyticsContext'
import './SubscriptionSuccess.css'

const SubscriptionSuccess = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { t } = useTranslation()
  const { user, loading, refreshProfile } = useAuth()
  const { trackEvent } = useAnalytics()
  const trackedRef = useRef(false)

  const reason = searchParams.get('reason') || 'subscription'

  useEffect(() => {
    if (loading) return
    if (!user) {
      navigate('/', { replace: true })
      return
    }
    if (trackedRef.current) return
    trackedRef.current = true
    trackEvent('funnel_subscription_success', { reason })
    refreshProfile?.()
  }, [user, loading, reason, trackEvent, refreshProfile, navigate])

  const handleContinue = () => {
    navigate('/app/people', { replace: true })
  }

  return (
    <div className="subscription-success-screen">
      <div className="subscription-success-content">
        <div className="subscription-success-image-wrap">
          <img src="/Paywall.png" alt="" className="subscription-success-image" />
        </div>
        <h1 className="subscription-success-title">{t('subscriptionSuccess.title')}</h1>
        <p className="subscription-success-description">{t('subscriptionSuccess.description')}</p>
        <button type="button" className="cta-button subscription-success-cta" onClick={handleContinue}>
          {t('subscriptionSuccess.continue')}
        </button>
      </div>
    </div>
  )
}

export default SubscriptionSuccess
